<template>
    <van-swipe-cell>
        <van-card
            :key="data.id"
            :num="data.qty"
            :price="data.price"
            :tags="data.cls1_name"
            :desc="data.car_products_spc"
            :title="data.car_products_name"
            :thumb="data.img_url"
            class="goods-card"
            @click="goDetail">
            <div slot="tags" class="tags">
                <van-tag type="primary">{{ data.cls_name }}{{ data.cls1_name }}</van-tag>
            </div>
        </van-card>
        <van-button
            slot="right"
            square
            text="删除"
            type="danger"
            class="delete-button"
            @click="delFav"
        />  
</van-swipe-cell>
</template>

<script>
import {
    SwipeCell, 
    Card,
    Tag,
    Button
} from 'vant'

export default {
    name: 'FavItem',
    components: {
        [SwipeCell.name]: SwipeCell,
        [Card.name]: Card,
        [Tag.name]: Tag,
        [Button.name]: Button
    },
    props: ['data'],
    methods: {
       goDetail() {
            this.$emit('goDetail', this.data)
       },
       delFav() {
           this.$emit('delFav', this.data)
       }
    }
}
</script>

<style>
.goods-card {
  margin: 0;
  background-color: white;
}

.delete-button {
  height: 100%;
}
</style>
